import * as Types from "./Types";

const initialState = {
  isCategory: false,
  isUpdate: false,
  isListLoading: false,
  statusUpdatingId: null,
  afterCreated: false,
  afterUpdated: false,
  afterDeleted: false,
  categoryList: null,
  categoryMeta: null,
  catImg: null,
  catIcon: null,
  catHoverIcon: null,
  isImageLoading: false,
  isIconLoading: false,
  isHoverIconLoading: false,
};
const CategoryReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case Types.IS_CREATE_CATEGORY:
      return {
        ...state,
        isCategory: action.payload,
      };
    case Types.IS_UPDATE_CATEGORY:
      return {
        ...state,
        isUpdate: action.payload,
      };
    case Types.AFTER_CREATED:
      return {
        ...state,
        afterCreated: action.payload,
      };
    case Types.AFTER_UPDATED:
      return {
        ...state,
        afterUpdated: action.payload,
      };
    case Types.CATEGORY_LIST:
      return {
        ...state,
        categoryList: action.payload,
      };
    case Types.CATEGORY_LIST_META:
      return {
        ...state,
        categoryMeta: action.payload,
      };
    case Types.AFTER_DELETED:
      return {
        ...state,
        afterDeleted: action.payload,
      };
    case Types.IS_CATEGORY_LIST_LOADING:
      return {
        ...state,
        isListLoading: action.payload,
      };
    case Types.IS_CATEGORY_STATUS_UPDATING:
      return {
        ...state,
        statusUpdatingId: action.payload,
      };
    case Types.CAT_IMG:
      return {
        ...state,
        catImg: action.payload,
      };
    case Types.CAT_ICON:
      return {
        ...state,
        catIcon: action.payload,
      };
    case Types.CAT_HOVER_ICON:
      return {
        ...state,
        catHoverIcon: action.payload,
      };
    case Types.IS_IMG_LOADING:
      return {
        ...state,
        isImageLoading: action.payload,
      };
    case Types.IS_ICON_LOADING:
      return {
        ...state,
        isIconLoading: action.payload,
      };
    case Types.IS_HOVER_ICON_LOADING:
      return {
        ...state,
        isHoverIconLoading: action.payload,
      };
    default:
      break;
  }
  return newState;
};
export default CategoryReducer;
